import styled from 'styled-components';

export const Container = styled.div`
  height: 38px;

  .material-icons {
    font-size: 20px;
  }

  .deadline-label {
    color: ${(props) => props.theme.$gray600};
    white-space: nowrap;
  }

  .DateRangePickerInput {
    display: flex;
    align-items: center;
    border: 0;
    padding-right: 28px;
    background: transparent;
  }

  .DateRangePickerInput_arrow {
    padding: 0 4px;
  }

  .DateInput {
    width: 96px;
    background: transparent;
  }

  .DateInput_input {
    padding: 4px;
    color: ${(props) => props.theme.$dark};
    background: transparent;
    border-bottom: 0;
  }

  .DateRangePickerInput_clearDates {
    margin: 0;
    padding: 4px;
  }

  .DateRangePicker_picker {
    z-index: 1050;
  }
`;
